import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const register = (data) => api.post('/register', data);
export const login = (data) => api.post('/login', data);
export const getMe = () => api.get('/me');
export const getRailwayData = () => api.get('/railway-data');
export const getRailwayDataByBureau = (bureau) => api.get(`/railway-data/${bureau}`);
export const createTransfer = (data) => api.post('/transfers', data);
export const getTransfers = (params) => api.get('/transfers', { params });
export const getMyTransfers = () => api.get('/transfers/my');
export const deleteTransfer = (id) => api.delete(`/transfers/${id}`);
export const getAdminTransfers = () => api.get('/admin/transfers');
export const updateTransferStatus = (id, status) => api.put(`/admin/transfers/${id}`, { status });
export const adminDeleteTransfer = (id) => api.delete(`/admin/transfers/${id}`);

export default api;
